import Vue from 'vue'
import './plugins/vuetify'
import App from './App.vue'
import router from './router'


var VueScrollTo = require('vue-scrollto');

Vue.use(VueScrollTo)


Vue.config.productionTip = false

new Vue({

  router,
  render: h => h(App)
}).$mount('#app')
